import { motion } from 'motion/react';
import styles from './Airplane.module.css';

import airplane from '../../assets/images/airplane.webp';

export const Airplane = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: '100vh' }}
      animate={{ opacity: 1, y: '0' }}
      transition={{ duration: 1 }}
      exit={{ opacity: 0, y: '100vh', transition: { duration: 1, delay: 0.5 } }}
      className={styles.bgVideoWrapper}
    >
      <motion.div
        initial={{ y: '0rem' }}
        animate={{
          y: [
            '0rem',
            '5.625rem',
            '-0.52rem',
            '5.625rem',
            '-0.52rem',
            '3.33rem',
            '0rem',
          ],
        }}
        transition={{
          times: [0, 0.2, 0.4, 0.6, 0.8, 0.9, 1],
          duration: 40,
          repeat: Infinity,
          ease: ['easeOut', 'easeIn', 'easeOut', 'easeIn', 'easeIn', 'easeIn'],
        }}
        className={styles.imgWrapper}
      >
        <img src={airplane} alt="" />
      </motion.div>
    </motion.div>
  );
};
